export default "__VITE_ASSET__CXrCC26x__"